import { Page } from '@app/components/page/Page';
import { Alert, AlertTitle, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { StationsBreadcrumbs } from '../../../components/base/stations/StationsBreadcrumbs';
import { AuditModule } from '../index';
import { Station } from '@app/core/types/stations';

interface Props {
  readonly station: Station;
}

export const AuditNotEnabledForStation = (p: Props) => {
  const { $t } = useIntl();

  return (
    <Page
      htmlTitle={$t(
        {
          id: 'audit.notEnabled.htmlTitle',
          defaultMessage: '{stationName} - Audit not enabled',
        },
        { stationName: p.station.name },
      )}
    >
      <Page.Header
        breadcrumbs={
          <StationsBreadcrumbs activeId={p.station.id} basePath={AuditModule.basePath} />
        }
      />
      <Page.Content>
        <Alert severity="warning">
          <AlertTitle>
            <FormattedMessage
              id="audit.notEnabledForStation.title"
              defaultMessage="This feature is not enabled for this station"
            />
          </AlertTitle>
          <FormattedMessage
            id="audit.notEnabledForStation.body"
            defaultMessage="Contact us to enable Audit for {stationName}."
            values={{
              stationName: (
                <Typography component="span" sx={{ fontWeight: 500 }}>
                  {p.station.name}
                </Typography>
              ),
            }}
          />
        </Alert>
      </Page.Content>
    </Page>
  );
};
